// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"x4-z","dimensionLabel":"y4-z","styleChooserControlWrapper":"z4-z","styleChooserControl":"A4-z","disabled":"B4-z","giftCard":"C4-z","styleChooserText":"D4-z"};